import { render, staticRenderFns } from "./VxCellPaymentCountryIconStatus.vue?vue&type=template&id=604a5b49&"
import script from "./VxCellPaymentCountryIconStatus.vue?vue&type=script&lang=js&"
export * from "./VxCellPaymentCountryIconStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports